var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavoritesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21l8.426-8.616c2.099-2.146 2.099-5.624 0-7.77A5.25 5.25 0 0016.626 3a5.31 5.31 0 00-3.814 1.614l-.827.846-.828-.846A5.25 5.25 0 007.358 3a5.192 5.192 0 00-3.784 1.614c-2.099 2.146-2.099 5.624 0 7.77L12 21zm3-9l-3-3-3 3 3 3 3-3z",
    fill: "#9A9CAC"
  })));
}

export default SvgFavoritesIcon;